export default "__VITE_ASSET__B_DD965J__"